const mutations = {
    setTransaction(state, data) {
        state.serviceRequestTransaction = data;
    },
    resetServiceRequestTransaction(state) {
        state.serviceRequestTransaction = {
            amount: null,
            paymentModeId: null,
            paymentNote: '',
            isAdvance: false
        }
    },
    setTransactionList(state, data) {
        state.serviceRequestTransactions = data;
    }
}

export default mutations;